import router from '../services/router_service';
import signupController from '../controllers/signup_controller';

router.on('route:signup', signupController);
